// Глобальная фокус-политика (правило frontend-page-layout): на тач-устройствах
// автофокуса НЕТ никогда — иначе штатная клавиатура открывается и закрывает
// сам инпут. На десктопе первое поле формы получает фокус сразу.
// Атрибут autofocus и ручные .focus() на mount — запрещены, только директива.
import { COARSE_POINTER_MQ, useMediaQuery } from '@/composables/useMediaQuery'
import type { Directive, Ref } from 'vue'

const FOCUSABLE = 'input, textarea, select, [contenteditable="true"]'

// Лениво: одна media-подписка на приложение, создаётся при первом mount.
let coarsePointer: Ref<boolean> | null = null

export const vAutofocus: Directive<HTMLElement> = {
  mounted(el) {
    coarsePointer ??= useMediaQuery(COARSE_POINTER_MQ)
    if (coarsePointer.value) return
    // rAF — позже встроенного автофокуса reka-ui при открытии диалога,
    // чтобы фокус оказался на нужном поле, а не на первом tabbable.
    requestAnimationFrame(() => {
      const target = el.matches(FOCUSABLE) ? el : el.querySelector<HTMLElement>(FOCUSABLE)
      target?.focus()
    })
  },
}
